import * as React from "react";
import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";

interface IProps {
}

const CustomerPartnerStore: React.FC<IProps> = (props) => {
    const [isCheck, setCheck] = React.useState(
        localStorage.getItem("partnerStoreTermsAccepted") === "1"
    );

    return (
        <React.Fragment>
            <Body>
                <InnerBody>
                    <New>New!!</New>
                    <Text1>エキスパートネットワークの</Text1>
                    <Text2>パートナーストア</Text2>
                    <Text1>
                        支援先のためにお得にサービスを紹介出来て、報酬まで獲得可能！
                    </Text1>
                    <SampleSectionTitle>パートナープロダクトの例</SampleSectionTitle>

                    <SampleSection>
                        <Sample>
                            <img
                                style={{width: 70, height: 45, marginRight: 20}}
                                src={Assets.partnerStoreIc1}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>SFAツール</p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の8%
                                </p>
                            </div>
                        </Sample>
                        <Sample>
                            <img
                                style={{width: 45, height: 48, marginRight: 20}}
                                src={Assets.partnerStoreIc2}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>
                                    サーベイツール
                                </p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の10%
                                </p>
                            </div>
                        </Sample>
                        <Sample>
                            <img
                                style={{width: 50, height: 36, marginRight: 20}}
                                src={Assets.partnerStoreIc3}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>MAツール</p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の4.7%
                                </p>
                            </div>
                        </Sample>
                        <Sample>
                            <img
                                style={{width: 50, height: 43, marginRight: 20}}
                                src={Assets.partnerStoreIc4}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>会計ツール</p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の13%
                                </p>
                            </div>
                        </Sample>
                        <Sample>
                            <img
                                style={{width: 50, height: 57, marginRight: 20}}
                                src={Assets.partnerStoreIc5}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>採用ツール</p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の15%
                                </p>
                            </div>
                        </Sample>
                        <Sample>
                            <img
                                style={{width: 30, height: 35, marginRight: 20}}
                                src={Assets.partnerStoreIc6}
                            />
                            <div>
                                <p style={{fontWeight: "bold", fontSize: 12}}>勤怠ツール</p>
                                <p style={{fontSize: 12, marginTop: 4, color: "#333"}}>
                                    契約金額の20%
                                </p>
                            </div>
                        </Sample>
                    </SampleSection>

                    <FlowSectionTitle>パートナーストア利用の3ステップ</FlowSectionTitle>
                    <FlowSection>
                        <Flow>
                            <FlowTitle>
                                <div>
                                    <FlowTitleNumber>1</FlowTitleNumber>
                                </div>

                                <FlowTitleText>
                                    パートナープロダクトを支援先に紹介する
                                </FlowTitleText>
                            </FlowTitle>

                            <img
                                style={{
                                    width: 60,
                                    display: "block",
                                    margin: "40px auto",
                                }}
                                src={Assets.partnerStoreFlow1}
                            />

                            <FlowText>
                                エキスパート（あなた様）は、パートナープロダクトリストの中から、支援先にマッチしそうなプロダクトを選定します。その製品に対して、支援先が興味を示した場合、紹介フォームに必要事項を記載し送信します。
                            </FlowText>
                        </Flow>

                        <TriangleRight/>

                        <Flow>
                            <FlowTitle>
                                <div>
                                    <FlowTitleNumber>2</FlowTitleNumber>
                                </div>

                                <FlowTitleText>支援先が、紹介を受けて契約する</FlowTitleText>
                            </FlowTitle>

                            <img
                                style={{
                                    width: 175,
                                    display: "block",
                                    margin: "40px auto",
                                    marginBottom: 20,
                                }}
                                src={Assets.partnerStoreFlow2}
                            />

                            <FlowText2>
                                プロダクトの導入にあたっての 面倒な仲介作業は不要です！
                            </FlowText2>

                            <FlowText>
                                紹介フォームの内容はLiberaを通じて、プロダクトの運営企業に送られます。運営企業の担当者より、紹介先（支援先担当者）に連絡が入り商談をします。紹介を受けた支援先はプロダクトごとに記載されている割引等の特典を受け取り、通常よりお得にサービスを利用する事が可能です。
                            </FlowText>
                        </Flow>

                        <TriangleRight/>

                        <Flow>
                            <FlowTitle>
                                <div>
                                    <FlowTitleNumber>3</FlowTitleNumber>
                                </div>

                                <FlowTitleText>報酬が振り込まれる</FlowTitleText>
                            </FlowTitle>

                            <img
                                style={{
                                    width: 75,
                                    display: "block",
                                    margin: "40px auto",
                                }}
                                src={Assets.partnerStoreFlow3}
                            />

                            <FlowText>
                                支援先企業とパートナープロダクト企業の合意が取れ成約に至った場合、その内容を通知するとともに、ご紹介頂きましたエキスパート（あなた様）に、弊社より報酬が支払われます。
                            </FlowText>
                        </Flow>
                    </FlowSection>

                    <div style={{width: 900, marginTop: 60}}>
                        {localStorage.getItem("partnerStoreTermsAccepted") !== "1" && (
                            <div style={{width: 200, margin: "0 auto"}}>
                                <input
                                    type="checkbox"
                                    id="check"
                                    checked={isCheck}
                                    style={{marginRight: 5}}
                                    onChange={(v) => {

                                        setCheck(v.target.checked);
                                    }}
                                />
                                <label style={{fontSize: 14}}>
                                    <a target="_blank"
                                       href={"https://storage.googleapis.com/term-storage/%E3%83%91%E3%83%BC%E3%83%88%E3%83%8A%E3%83%BC%E3%82%B9%E3%83%88%E3%82%A2_%E5%80%8B%E4%BA%BA_%E9%A1%A7%E5%AE%A2%E7%B4%B9%E4%BB%8B%E6%A5%AD%E5%8B%99%E5%8F%97%E8%A8%97%E8%A6%8F%E7%B4%84_%E6%8E%B2%E8%BC%89%E7%94%A8.pdf"}>利用規約</a>
                                    に合意する
                                </label>
                            </div>
                        )}

                        {isCheck ? (
                            <Button>
                                <a
                                    style={{color: "white"}}
                                    onClick={() => {
                                        localStorage.setItem("partnerStoreTermsAccepted", "1");
                                    }}
                                    href="/customer/partner-store-list"
                                >
                                    紹介できるプロダクトをみる
                                </a>
                            </Button>
                        ) : (
                            <DisableButton>紹介できるプロダクトをみる</DisableButton>
                        )}
                    </div>
                </InnerBody>
            </Body>
        </React.Fragment>
    );
};

export default CustomerPartnerStore;

const Body = styled.div`
    background-image: url(${Assets.partnerStoreBg});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 550px;
    padding: 40px 70px;
`;

const InnerBody = styled.div`
    width: 900px;
    margin: 0 auto;
`;

const New = styled.div`
    color: #fac949;
    font-weight: bold;
    font-size: 18px;
`;

const Text1 = styled.div`
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    margin-top: 12px;
`;

const Text2 = styled.div`
    color: #fff;
    font-weight: bold;
    font-size: 40px;
    margin-top: 12px;
`;

const SampleSectionTitle = styled.div`
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    margin-top: 40px;
`;

const SampleSection = styled.div`
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 900px;
`;

const Sample = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 230px;
    height: 100px;
    border-radius: 10px;
    background-color: #f7fefb;
    margin: 15px 5px;
`;

const FlowSectionTitle = styled.div`
    color: #333;
    margin-top: 90px;
    font-size: 22px;
    font-weight: bold;
`;

const FlowSection = styled.div`
    display: flex;
    margin-top: 16px;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 900px;
`;

const Flow = styled.div`
    width: 230px;
`;

const FlowTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const FlowTitleNumber = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 13px;
    background-color: #00a8b2;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const FlowTitleText = styled.div`
    font-size: 16px;
    font-weight: bold;
    margin-left: 10px;
    line-height: 24px;
`;

const FlowText = styled.div`
    font-size: 12px;
    line-height: 20px;
`;

const FlowText2 = styled.div`
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    margin-bottom: 10px;
    padding: 0px 20px;
`;

const TriangleRight = styled.div`
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 20px solid #00a8b2;
    margin: 0px 15px;
    margin-top: 150px;
`;

const Button = styled.button`
    width: 320px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #00a8b2;
    border-radius: 2px;
    margin: 0 auto;
    margin-top: 20px;
    border: none;
`;

const DisableButton = styled.button`
    width: 320px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #d3d3d3;
    border-radius: 2px;
    margin: 0 auto;
    margin-top: 20px;
    border: none;
`;

const getLocalStorageValue = (key: string) => {
    const item = localStorage.getItem(key);
    return item ? item : "";
};

export const useLocalStorage = (key: string) => {
    const [value, setValue] = React.useState(() => getLocalStorageValue(key));

    const setLocalStorageValue = React.useCallback(
        (setStateAction: string | ((prevState: string) => string)) => {
            const newValue =
                setStateAction instanceof Function
                    ? setStateAction(value)
                    : setStateAction;

            localStorage.setItem(key, newValue);
            setValue(() => newValue);
        },
        [key, value]
    );

    return [value, setLocalStorageValue] as const;
};



// WEBPACK FOOTER //
// ./src/presentation/container/customer_partner_store.tsx